import { createAuthClient } from 'better-auth/react';
import { emailOTPClient } from 'better-auth/client/plugins';

// Point directly to the backend so OAuth state cookies are set on the same
// domain that receives the Google callback (fixes state_mismatch).
const apiURL =
  import.meta.env.VITE_API_URL ||
  (typeof window !== 'undefined' && window.location?.origin !== 'null'
    ? window.location.origin
    : 'http://localhost:3000');

export const authClient = createAuthClient({
  baseURL: apiURL,
  basePath: '/api/auth',
  plugins: [emailOTPClient()],
});

export type Session = typeof authClient.$Infer.Session;
